module.exports = __webpack_public_path__ + "static/media/illuminate.be374480.png";